import {configureStore} from '@reduxjs/toolkit'
import RegisterMainReducer from '../features/register/RegisterMainSlice';
import RegisterPetShopReducer from '../features/register/RegisterShopSlice';
import MyPointReducer from '../features/MyPointSlice';
import QuestionnaireReducer from '../features/QuestionnaireSlice';
import LoadingReducer from '../features/LoadingSlice';
import LuckyDrawSlice from '../features/LuckyDrawSlice';
import MemberSlice from '../features/MemberSlice';
import ShopSlice from '../features/ShopSlice';

export default configureStore({
  reducer: {
    registerMain: RegisterMainReducer,
    RegisterShop: RegisterPetShopReducer,
    myPoint: MyPointReducer,
    questionnaire: QuestionnaireReducer,
    loading: LoadingReducer,
    luckyDraw: LuckyDrawSlice ,
    member: MemberSlice,
    shop: ShopSlice 
  },
})